import styled from 'styled-components';
import { ContainerBase } from './containerBase';

// Generic vertical layout
export const VerticalLayout = styled(ContainerBase)`
    max-width: ${(props) => props.theme.size.container};
`;
